import { useState } from 'react'

import { getInvoiceFileLink } from '@/api/models/finance/lib/finance.utils'
import { ScreenSize } from '@/app/constants/index'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { openUrlInNewTab } from '@/utils/file'

interface UseOpenInvoiceFile {
  isModalOpen: boolean
  setIsModalOpen: (_: boolean) => void
  handleOpenFile: (fileId: string) => Promise<void>
}

export const useOpenInvoiceFile = (): UseOpenInvoiceFile => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xs, ScreenSize.Xxs].includes(breakpoint)

  const handleOpenFile = async (fileId: string): Promise<void> => {
    const { isSuccess, url } = await getInvoiceFileLink(fileId)
    if (!isSuccess) {
      setIsModalOpen(true)
      return
    }

    if (!url) {
      return
    }

    if (isMobileScreen) {
      requestAnimationFrame(() => {
        openUrlInNewTab(url)
      })
    } else {
      openUrlInNewTab(url)
    }
  }

  return { isModalOpen, setIsModalOpen, handleOpenFile }
}
